module.exports = __webpack_public_path__ + "static/media/icon_81.304f4437.svg";